module.exports = __webpack_public_path__ + "img/nodeBackgroundGradient.8c4203a9.svg";